import React from "react";
// Common Components
import { Button, Modal, DynamicDropdown } from "src/Components";
import SelectableButtons from "src/Components/Dropdown/SelectableButtons";
import UsersDropdown from "src/Components/Dropdown/Users/UsersDropdown";
// Local Components
import SettingConfig from "./SettingModal";
import HedgerDuedateTable from "./HedgerDuedateTable";
import HedgerAccountDuedateTable from "./HedgerAccountDuedateTable";
import HedgerDuedateChart from "./HedgerDuedateChart";
import HedgerAccountDuedateChart from "./HedgerAccountDuedateChart";
// Types
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { IIVOptionSearchParams } from "src/Interfaces/automaticMarketMaking";
// Requests
import { getDueDates } from "src/Requests/optionGreek";
import {
  getbaseInstrumentAccounts,
  getDistinctBaseInstrument,
} from "src/Requests/automaticMarketMaking";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";

const IVOption: React.FC = () => {
  // local store
  const [isConfigOpen, setIsConfigOpen] = React.useState(false);

  const [searchParam, setSearchParam] = React.useState(
    {} as IIVOptionSearchParams
  );
  const [baseInstruments, setBaseInstruments] = React.useState(
    [] as DropdownItem[]
  );
  const [toDates, setToDates] = React.useState([] as DropdownItem[]);
  const [accounts, setAccounts] = React.useState([] as DropdownItem[]);

  React.useEffect(() => {
    getDistinctBaseInstrument()
      .then((resp) => {
        setSearchParam({ ...searchParam, baseInsId: resp[0]?.id });
        setBaseInstruments(resp);
      })
      .catch(packetErrorHandler);
  }, []);

  React.useEffect(() => {
    if (searchParam.baseInsId) {
      Promise.all([
        getDueDates(searchParam.baseInsId.toString()),
        getbaseInstrumentAccounts(searchParam.baseInsId.toString()),
      ])
        .then(([dueDates, accounts]) => {
          setToDates(dueDates);
          setAccounts(accounts);

          let search = {} as IIVOptionSearchParams;
          if (dueDates[0].id) search.toDate = dueDates[0]?.id;
          if (accounts[0].id) search.accountId = accounts[0]?.id;
          if (!search.baseInsId) search.baseInsId = searchParam.baseInsId;
          setSearchParam(
            Object.fromEntries(
              Object.entries(search).filter(([_, value]) => value !== null)
            ) as IIVOptionSearchParams
          );
        })
        .catch(packetErrorHandler);
    }
  }, [searchParam.baseInsId]);

  const changeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  const ShowDetails = () => {
    if (searchParam.accountId && searchParam.toDate && searchParam.baseInsId) {
      return (
        <>
          <div className="w-full h-full flex justify-between items-center gap-6 p-3 mb-7">
            <HedgerDuedateChart searchParam={searchParam} />
            <HedgerAccountDuedateChart searchParam={searchParam} />
          </div>
          <HedgerDuedateTable searchParam={searchParam} />
          <HedgerAccountDuedateTable searchParam={searchParam} />
        </>
      );
    }
    return <></>;
  };

  return (
    <div className="w-full h-full">
      {isConfigOpen ? (
        <Modal
          title="تنظیمات"
          onClose={() => setIsConfigOpen(false)}
          UI={<SettingConfig onClose={() => setIsConfigOpen(false)} />}
          modalBoxClassName="!min-w-[0px] !min-h-[0px]"
        />
      ) : (
        <></>
      )}
      <div className="w-full flex justify-between items-center gap-3">
        <div className="flex justify-start items-start gap-6 p-3">
          <SelectableButtons
            label="نماد پایه"
            name="baseInsId"
            onChange={changeHandler}
            options={baseInstruments}
            value={searchParam.baseInsId}
            hideSelectAll
          />
          {accounts.length > 0 ? (
            <SelectableButtons
              label="نام اکانت"
              name="accountId"
              onChange={changeHandler}
              options={accounts}
              value={searchParam.accountId}
              hideSelectAll
            />
          ) : (
            <></>
          )}
        </div>
        <div>
          <Button
            onClick={() => setIsConfigOpen(true)}
            text="تنظیمات"
            variant="contained"
          />
        </div>
      </div>
      <div className="w-full flex justify-between items-center gap-6 p-3 mb-7">
        <SelectableButtons
          label="سررسید"
          name="toDate"
          onChange={changeHandler}
          options={toDates}
          value={searchParam.toDate}
          hideSelectAll
        />
      </div>
      {ShowDetails()}
    </div>
  );
};

export default IVOption;
